import type { ComponentProps } from "react";
import { cn } from "~/lib/utils";

type TagProps = ComponentProps<"span">;

export function Tag({ children, className, ...props }: TagProps) {
  return (
    <span
      className={cn("inline-flex items-center gap-1 rounded-full bg-muted px-2 py-0.5 text-xs", className)}
      {...props}
    >
      {children}
    </span>
  );
}
